import { deleteMissionFileFunctionDef } from '../../../../backend/features/mission-files/shared';
import { useMissionsTranslation } from '../../../../ui/hooks';
import { handleErrorDialog } from '@juvare/common-web-ui/DialogHelper';
import { showAlertSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { useTypedPlatformFunction } from '@juvare/platform-sdk-react/ui/features/typed-platform-functions';
import React from 'react';
export const useMissionFileActions = () => {
    const { t } = useMissionsTranslation();
    const deleteFilePlatformFn = useTypedPlatformFunction(deleteMissionFileFunctionDef);
    const handleFileDelete = React.useCallback((fileId, onSuccess) => {
        deleteFilePlatformFn({ fileId })
            .then(() => {
            showAlertSnackbar({
                horizontalPosition: 'center',
                type: 'success',
                autoHideDuration: 2000,
                verticalPosition: 'bottom',
                message: t('missions.file.deleteDialog.deletedSnackbar'),
            });
            onSuccess();
        })
            .catch(handleErrorDialog);
    }, [deleteFilePlatformFn, t]);
    return {
        deleteFile: handleFileDelete,
    };
};
